export function humbergerMenuButton(buttonEl, menuEl) {
  if ($(buttonEl).length) {
    var state = false;
    var pos;
    // $('html').removeClass('l-main--scrollstop');
    $(buttonEl).on("click", function () {
      if (state == false) {
        $(this).addClass("active");
        pos = $(window).scrollTop();
        $('html').addClass('l-main--scrollstop').css({'top': -pos});
        $(this).children(".c-toggle__body").addClass("active");
        $(menuEl).slideToggle();
        state = true;
      } else {
        $(this).removeClass("active");
        $('html').removeClass('l-main--scrollstop').css({'top': 0});
        window.scrollTo(0, pos);
        $(this).children(".c-toggle__body").removeClass("active");
        $(menuEl).slideToggle();
        state = false;
      }
      // $(this).toggleClass("active");
      // $('html').toggleClass('l-main--scrollstop');
      // $(this).children(".c-toggle__body").toggleClass("active");
      // $(menuEl).slideToggle();
    });
    $('#humberge-close').on("click", function() {
      $(".c-toggle").removeClass("active");
      $('html').removeClass('l-main--scrollstop').css({'top': 0});
      window.scrollTo(0, pos);
      $(".c-toggle__body").removeClass("active");
      $(menuEl).slideUp();
      state = false;
      // $(".c-toggle").removeClass("active");
      // $('html').toggleClass('l-main--scrollstop');
      // $(".c-toggle__body").removeClass("active");
      // $(menuEl).slideUp();
    })
  }
}
